import Vue from 'vue';
import { mapGetters } from 'vuex';
import loadingDroplet from '@editor/droplets/_bubble-options/components/loading-droplet';

export default Vue.component('section-droplets', {
  template: require('./template.html'),
  name: 'section-droplets',
  components: {
    loadingDroplet,
  },
  props: [
    'droplet',
    'display',
    'show-edit-bubble',
    'descendants',
  ],
  computed: {
    ...mapGetters(['currentPage', 'globalDragEl']),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    draggingTemplateDrp() {
      return this.globalDragEl === 'templateDroplet';
    },
  },
  watch: {
    'droplet.droplets': function watchDroplets() {
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.renderKey = Date.now();
    },
  },
  data() {
    const renderKey = Date.now();
    return {
      renderKey,
    };
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/section-droplets/index.js